import React from 'react';

// STYLES
import { TextField, Typography, InputAdornment, IconButton, Tooltip } from '@mui/material';

// ICONS
import AddIcon from '@mui/icons-material/Add';

export default function InputFields({
  cellPhone,
  setCellPhone,
  cpf,
  setCpf,
  cnpj,
  setCnpj,
  email,
  setEmail,
  verifyEmail,
  validateEmail,
  cellPhoneMask,
  cpfMask,
  maskCnpj,
  addUser,
  loadingValidateUserMapfre,
}) {
  // objeto comum para InputProps, incluindo o ícone de adicionar usuário
  const commonInputProps = {
    endAdornment: (
      <InputAdornment
        position="end"
        sx={{
          cursor: 'pointer',
          height: 'max-content',
          width: 'max-content',
        }}
      >
        <Tooltip title="Adicionar" placement="top">
          <span>
            <IconButton
              edge="end"
              size="small"
              color="tertiary"
              onClick={addUser}
              disabled={loadingValidateUserMapfre}
            >
              <AddIcon />
            </IconButton>
          </span>
        </Tooltip>
      </InputAdornment>
    ),
    onKeyDown: (e) => {
      if (e.key === 'Enter' && !loadingValidateUserMapfre) {
        e.preventDefault();
        addUser();
      }
    },
  };

  // textfield para adicionar usuarios a lista (club)
  const renderInputByClubKey = (clubKey) => {
    switch (clubKey) {
      case 'cellPhone':
        return (
          <TextField
            placeholder="(99) 99999-9999"
            variant="outlined"
            required
            label="Telefone:"
            value={cellPhone}
            onChange={(e) => setCellPhone(cellPhoneMask(e.target.value))}
            sx={{ width: 300 }}
            InputProps={commonInputProps}
          />
        );

      case 'cpf':
        return (
          <TextField
            placeholder="000.000.000-00"
            label="CPF:"
            variant="outlined"
            required
            value={cpf}
            onChange={(e) => setCpf(cpfMask(e.target.value))}
            sx={{ width: 300 }}
            InputProps={commonInputProps}
          />
        );

      case 'cnpj':
        return (
          <TextField
            placeholder="00.000.000/0000-00"
            label="CNPJ:"
            variant="outlined"
            required
            value={cnpj}
            onChange={(e) => setCnpj(maskCnpj(e.target.value))}
            sx={{ width: 300 }}
            InputProps={commonInputProps}
          />
        );

      case 'email':
        return (
          <TextField
            placeholder="example@example.com.br"
            label="Email:"
            variant="outlined"
            required
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              validateEmail(e.target.value);
            }}
            error={!!email && !verifyEmail}
            helperText={!!email && !verifyEmail ? 'Email inválido' : ''}
            FormHelperTextProps={{ sx: { paddingLeft: 0, marginLeft: 0 } }}
            sx={{ width: { xs: 300, sm: 330, md: 400 } }}
            InputProps={commonInputProps}
          />
        );

      default:
        return (
          <Typography variant="subtitle2" color="error">
            Tipo de chave inválida.
          </Typography>
        );
    }
  };

  // textfield para adicionar usuarios a lista (estabelecimento)
  const renderInputEstablishment = () => (
    <TextField
      placeholder="(99) 99999-9999"
      variant="outlined"
      required
      label="Telefone:"
      value={cellPhone}
      onChange={(e) => setCellPhone(cellPhoneMask(e.target.value))}
      sx={{ width: 300 }}
      InputProps={commonInputProps}
    />
  );

  return { renderInputByClubKey, renderInputEstablishment };
}
